import styled from "@emotion/styled";
import { Box } from "@otrium/core";
const Wrapper = styled(Box)`
  height: 64px;
  width: 100%;
  background-image: linear-gradient(to bottom, #000000, rgba(0, 0, 0, 0));
  opacity: 0.75;
  position: absolute;
  top: 0;
  z-index: 10;
`;
export { Wrapper };
